import { SET_ALLERGENS } from "../actions";

export default function setAllergens(state = [], action) {
  switch (action.type) {
    case SET_ALLERGENS:
      return action.payload;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/allergens.js